/**
 * Adaprox Theme — Product Form JavaScript
 * Handles: image gallery, variant selection, quantity, AJAX add-to-cart
 */

(function () {
  'use strict';

  /* ─── 1. Product Image Gallery ─── */
  var mainImage = document.querySelector('[data-main-image]');
  var thumbnails = document.querySelectorAll('[data-thumb]');

  if (mainImage && thumbnails.length > 0) {
    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        // Update main image
        var src = this.getAttribute('data-full-src');
        var alt = this.getAttribute('data-full-alt') || '';
        if (src && mainImage) {
          mainImage.src = src;
          mainImage.alt = alt;
        }

        // Update active state
        thumbnails.forEach(function (t) {
          t.classList.remove('is-active');
        });
        this.classList.add('is-active');
      });
    });
  }

  /* ─── 2. Variant Selection ─── */
  var productForm = document.getElementById('ProductForm');
  var variantIdInput = document.querySelector('[data-variant-id]');
  var priceDisplay = document.querySelector('[data-product-price]');
  var comparePriceDisplay = document.querySelector('[data-compare-price]');
  var addToCartBtn = document.querySelector('[data-add-to-cart]');
  var addToCartText = document.querySelector('[data-add-to-cart-text]');
  var addToCartOriginal = addToCartText ? addToCartText.textContent : '';
  var variantJson = document.querySelector('[data-variant-json]');
  var variants = [];

  if (variantJson) {
    try {
      variants = JSON.parse(variantJson.textContent);
    } catch (e) {
      console.error('Failed to parse variant JSON', e);
    }
  }

  // Track selected options
  var selectedOptions = {};

  document.querySelectorAll('[data-option-group]').forEach(function (group) {
    var optionName = group.getAttribute('data-option-group');
    var buttons = group.querySelectorAll('[data-option-value]');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = this.getAttribute('data-option-value');
        selectedOptions[optionName] = value;

        // Update active state within group
        buttons.forEach(function (b) {
          b.classList.remove('is-active');
        });
        this.classList.add('is-active');

        // Find matching variant
        updateVariant();
      });

      // Set initial selection
      if (btn.classList.contains('is-active')) {
        selectedOptions[optionName] = btn.getAttribute('data-option-value');
      }
    });
  });

  function updateVariant() {
    if (variants.length === 0) return;

    var match = variants.find(function (v) {
      return v.options.every(function (opt, i) {
        var optionName = 'option' + (i + 1);
        // Check against selected options by position
        var keys = Object.keys(selectedOptions);
        if (i < keys.length) {
          return opt === selectedOptions[keys[i]];
        }
        return true;
      });
    });

    if (match) {
      if (variantIdInput) variantIdInput.value = match.id;

      if (priceDisplay) {
        priceDisplay.textContent = formatMoney(match.price);
      }

      if (comparePriceDisplay) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          comparePriceDisplay.textContent = formatMoney(match.compare_at_price);
          comparePriceDisplay.style.display = '';
        } else {
          comparePriceDisplay.style.display = 'none';
        }
      }

      if (addToCartBtn) {
        if (match.available) {
          addToCartBtn.disabled = false;
          updateAddToCartText();
        } else {
          addToCartBtn.disabled = true;
          if (addToCartText) addToCartText.textContent = 'Sold Out';
        }
      }
    }
  }

  /* ─── 3. Quantity Controls ─── */
  var qtyInput = document.querySelector('[data-qty-input]');
  var qtyMinus = document.querySelector('[data-qty-minus]');
  var qtyPlus = document.querySelector('[data-qty-plus]');
  var qtyHidden = document.querySelector('[data-qty-hidden]');

  if (qtyMinus) {
    qtyMinus.addEventListener('click', function () {
      var val = parseInt(qtyInput.textContent || '1', 10);
      if (val > 1) {
        qtyInput.textContent = val - 1;
        if (qtyHidden) qtyHidden.value = val - 1;
        updateAddToCartText();
      }
    });
  }

  if (qtyPlus) {
    qtyPlus.addEventListener('click', function () {
      var val = parseInt(qtyInput.textContent || '1', 10);
      qtyInput.textContent = val + 1;
      if (qtyHidden) qtyHidden.value = val + 1;
      updateAddToCartText();
    });
  }

  function getQuantity() {
    if (qtyInput) return parseInt(qtyInput.textContent || '1', 10);
    return 1;
  }

  function updateAddToCartText() {
    if (!addToCartText || !priceDisplay) {
      // No price element — restore saved original text
      if (addToCartText && addToCartOriginal) {
        addToCartText.textContent = addToCartOriginal;
      }
      return;
    }
    var priceText = priceDisplay.textContent;
    var qty = getQuantity();
    // Extract numeric value from price text
    var priceNum = parseFloat(priceText.replace(/[^0-9.]/g, ''));
    if (!isNaN(priceNum)) {
      var total = (priceNum * qty).toFixed(2);
      addToCartText.textContent = 'Add to Cart \u2014 $' + total;
      addToCartOriginal = addToCartText.textContent;
    }
  }

  /* ─── 4. AJAX Add to Cart ─── */
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var variantId = variantIdInput ? variantIdInput.value : '';
      var quantity = getQuantity();

      if (!variantId) return;

      // Disable button + show spinner
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        if (addToCartText) addToCartText.innerHTML = '<svg class="animate-spin h-5 w-5 mx-auto" viewBox="0 0 24 24" fill="none"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3"/><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/></svg>';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parseInt(variantId, 10),
          quantity: quantity,
        }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          // Restore button immediately
          if (addToCartBtn) {
            addToCartBtn.disabled = false;
            updateAddToCartText();
          }

          // Open cart drawer (or fallback to badge update)
          if (window.openCartDrawer) {
            window.openCartDrawer();
          } else {
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                if (window.updateCartCount) window.updateCartCount(cart.item_count);
              });
            if (window.showCartNotification) window.showCartNotification('Added to Cart!');
          }
        })
        .catch(function (err) {
          console.error(err);
          if (addToCartBtn) {
            addToCartBtn.disabled = false;
            if (addToCartText) addToCartText.textContent = 'Error \u2014 Try Again';
            setTimeout(function () {
              updateAddToCartText();
            }, 2000);
          }
        });
    });
  }

  /* ─── Helpers ─── */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

})();
